import './activity-modal.css'

import React, { useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'

import { GroupOffers } from '../../../common/components/GroupOffers'
import User from '../../../dtos/User'
import { IActivity, ICalendarGroup } from '../types'

declare global {
  interface Window {
    // Injected by iframe-resizer's contentWindow script (see ActivitySubscription.tsx).
    // Absent when the app is not embedded in an iframe.
    parentIFrame?: {
      scrollTo: (x: number, y: number) => void
      scrollToOffset: (x: number, y: number) => void
    }
  }
}

interface IActivityModalProps {
  user: Partial<User> | null
  isOpened: boolean
  onClose: () => void
  goToLogin: () => void
  activity: IActivity | undefined
  group: ICalendarGroup | undefined
  shopUrl: string | undefined
  organizationSlug: string | undefined
}

export const ActivityModal: React.FC<IActivityModalProps> = ({
  isOpened,
  onClose,
  activity,
  group,
  ...groupOffersProps
}) => {

    useEffect(() => {
        if (!isOpened || !group) {
            return;
        }

        // The modal is `position: fixed` inside an iframe that iframe-resizer
        // stretches to its full content height, so it is centered against that
        // height rather than the visible viewport. Scrolling the *host* page
        // back to the top of the iframe brings the modal header (and its close
        // button) back into view.
        if (window.parentIFrame) {
            window.parentIFrame.scrollToOffset(0, 0);
        } else {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    }, [isOpened]);

    const styleClasses = (
        group && activity && [
            `group-${group.id}`,
            ...activity.categories.map(({id}) => `category-${id}`),
            `program-${group.programmation_id}`,
            `activity-${activity.id}`
        ]
    ) || [];

  return (
    <>
      {activity && group && (
          <Modal
              id={"activity-modal-" + group.id}
              contentClassName={styleClasses.join(" ")}
              show={isOpened}
              onHide={onClose}
              backdrop="static"
              dialogClassName="modal-dialog_activity "
              centered>
          <GroupOffers
            onContinueShopping={onClose}
            activity={activity}
            group={group}
            shouldRedirectToLogin={false}
            {...groupOffersProps}
          />
        </Modal>
      )}
    </>
  )
}
